import HomeCard from '../../components/HomeCard/HomeCard'
import { CardWrapper, Container, HeaderWrapper, SubHeader } from './Home.styles'
import { useGetBrands } from '../../hooks/api'
import Toast, { ToastIntentEnum } from '../../components/Toast/Toast'
import { Brand } from '../../services/types/brands'
import LoadingSpinner from '../../components/LoadingSpinner/LoadingSpinner'

const Home = () => {
  const { data: brands, error, isLoading } = useGetBrands()

  if (isLoading) {
    return <LoadingSpinner />
  }

  if (error) {
    return (
      <Toast
        triggerToast={ToastIntentEnum.Error}
        title={error.message || 'There was an error getting the data'}
      />
    )
  }

  return (
    <>
      <Container>
        <HeaderWrapper>
          <h1>Welcome to the ABG Truck load Calculator</h1>
          <SubHeader>
            Please select a brand to build your truck load in order to meet a
            half or full load!
          </SubHeader>
        </HeaderWrapper>
      </Container>
      <CardWrapper>
        {brands
          ?.sort((a, b) => a.order - b.order)
          .map((brand: Brand) => (
            <HomeCard
              key={brand.id}
              brandId={brand.id}
              link={brand.name}
              title={brand.name}
              img={brand.img}
              description={brand.description}
            />
          ))}
      </CardWrapper>
    </>
  )
}

export default Home
